import { BonusPromotionStatus } from 'shared/models/Promotion'

export const bonusPromotionStatusWeights = {
  [BonusPromotionStatus.wait]: 99,
  [BonusPromotionStatus.completed]: 51,
  [BonusPromotionStatus.active]: 50,
  [BonusPromotionStatus.available]: 10,
  [BonusPromotionStatus.available_completed]: 10,
  [BonusPromotionStatus.expired]: 0,
  [BonusPromotionStatus.paid]: 0,
}

export const takeYourBonusStatuses = [
  BonusPromotionStatus.wait,
  BonusPromotionStatus.available,
  BonusPromotionStatus.available_completed,
]

export const activePromotionStatuses = [BonusPromotionStatus.completed, BonusPromotionStatus.active]
